import { createAsyncThunk } from "@reduxjs/toolkit";


export const getInboundShipments = createAsyncThunk(
  'fetchInboundShipments/getAll',
  async (url) => {
    const response = await fetchInboundShipments(url)
    return response
  }
)

export const fetchInboundShipments = (url) => new Promise((resolve, reject) =>
  setTimeout(() => resolve(inboundShipmentData), 2000))


export const inboundShipmentData = [{
  shipment_number: '000000000128517',
  supplier: 'Supplier A',
  customer: 'Customer X',
  carrier: 'Carrier 1',
  planned_shiped_date: 'Dec 23, 2024 , 4:00 PM UTC',
  header_state: 'In Transit',
  eta: 'Dec 23, 2024 , 4:00 PM UTC',
  pta: 'Dec 23, 2024 , 4:00 PM UTC',
  creation_date: 'Dec 23, 2024 , 4:00 PM UTC',
  notes: 'Urgent delivery',
  lmd: 'Dec 23, 2024 , 4:00 PM UTC',
},
{
  shipment_number: '0000000001258494',
  supplier: 'Supplier B',
  customer: 'Customer Y',
  carrier: 'Carrier 1',
  planned_shiped_date: 'Dec 23, 2024 , 4:00 PM UTC',
  header_state: 'Delivered',
  eta: 'Dec 23, 2024 , 4:00 PM UTC',
  pta: 'Dec 23, 2024 , 4:00 PM UTC',
  creation_date: 'Dec 23, 2024 , 4:00 PM UTC',
  notes: 'Handle with care',
  lmd: 'Dec 23, 2024 , 4:00 PM UTC',
},
{
  shipment_number: '0000000001258494',
  supplier: 'Supplier B',
  customer: 'Customer Y',
  carrier: 'Carrier 1',
  planned_shiped_date: 'Dec 23, 2024 , 4:00 PM UTC',
  header_state: 'Delivered',
  eta: 'Dec 23, 2024 , 4:00 PM UTC',
  pta: 'Dec 23, 2024 , 4:00 PM UTC',
  creation_date: 'Dec 23, 2024 , 4:00 PM UTC',
  notes: 'Handle with care',
  lmd: 'Dec 23, 2024 , 4:00 PM UTC',
},
{
  shipment_number: '0000000001258494',
  supplier: 'Supplier B',
  customer: 'Customer Y',
  carrier: 'Carrier 1',
  planned_shiped_date: 'Dec 23, 2024 , 4:00 PM UTC',
  header_state: 'Delivered',
  eta: 'Dec 23, 2024 , 4:00 PM UTC',
  pta: 'Dec 23, 2024 , 4:00 PM UTC',
  creation_date: 'Dec 23, 2024 , 4:00 PM UTC',
  notes: 'Handle with care',
  lmd: 'Dec 23, 2024 , 4:00 PM UTC',
},
{
  shipment_number: '0000000001258494',
  supplier: 'Supplier B',
  customer: 'Customer Y',
  carrier: 'Carrier 1',
  planned_shiped_date: 'Dec 23, 2024 , 4:00 PM UTC',
  header_state: 'Delivered',
  eta: 'Dec 23, 2024 , 4:00 PM UTC',
  pta: 'Dec 23, 2024 , 4:00 PM UTC',
  creation_date: 'Dec 23, 2024 , 4:00 PM UTC',
  notes: 'Handle with care',
  lmd: 'Dec 23, 2024 , 4:00 PM UTC',
},
{
  shipment_number: '0000000001258494',
  supplier: 'Supplier B',
  customer: 'Customer Y',
  carrier: 'Carrier 1',
  planned_shiped_date: 'Dec 23, 2024 , 4:00 PM UTC',
  header_state: 'Delivered',
  eta: 'Dec 23, 2024 , 4:00 PM UTC',
  pta: 'Dec 23, 2024 , 4:00 PM UTC',
  creation_date: 'Dec 23, 2024 , 4:00 PM UTC',
  notes: 'Handle with care',
  lmd: 'Dec 23, 2024 , 4:00 PM UTC',
},
{
  shipment_number: '0000000001258494',
  supplier: 'Supplier B',
  customer: 'Customer Y',
  carrier: 'Carrier 1',
  planned_shiped_date: 'Dec 23, 2024 , 4:00 PM UTC',
  header_state: 'Delivered',
  eta: 'Dec 23, 2024 , 4:00 PM UTC',
  pta: 'Dec 23, 2024 , 4:00 PM UTC',
  creation_date: 'Dec 23, 2024 , 4:00 PM UTC',
  notes: 'Handle with care',
  lmd: 'Dec 23, 2024 , 4:00 PM UTC',
},
{
  shipment_number: '0000000001258494',
  supplier: 'Supplier B',
  customer: 'Customer Y',
  carrier: 'Carrier 1',
  planned_shiped_date: 'Dec 23, 2024 , 4:00 PM UTC',
  header_state: 'Delivered',
  eta: 'Dec 23, 2024 , 4:00 PM UTC',
  pta: 'Dec 23, 2024 , 4:00 PM UTC',
  creation_date: 'Dec 23, 2024 , 4:00 PM UTC',
  notes: 'Handle with care',
  lmd: 'Dec 23, 2024 , 4:00 PM UTC',
},
{
  shipment_number: '0000000001258494',
  supplier: 'Supplier B',
  customer: 'Customer Y',
  carrier: 'Carrier 1',
  planned_shiped_date: 'Dec 23, 2024 , 4:00 PM UTC',
  header_state: 'Delivered',
  eta: 'Dec 23, 2024 , 4:00 PM UTC',
  pta: 'Dec 23, 2024 , 4:00 PM UTC',
  creation_date: 'Dec 23, 2024 , 4:00 PM UTC',
  notes: 'Handle with care',
  lmd: 'Dec 23, 2024 , 4:00 PM UTC',
},
{
  shipment_number: '0000000001258494',
  supplier: 'Supplier B',
  customer: 'Customer Y',
  carrier: 'Carrier 1',
  planned_shiped_date: 'Dec 23, 2024 , 4:00 PM UTC',
  header_state: 'Delivered',
  eta: 'Dec 23, 2024 , 4:00 PM UTC',
  pta: 'Dec 23, 2024 , 4:00 PM UTC',
  creation_date: 'Dec 23, 2024 , 4:00 PM UTC',
  notes: 'Handle with care',
  lmd: 'Dec 23, 2024 , 4:00 PM UTC',
},
{
  shipment_number: '0000000001258494',
  supplier: 'Supplier B',
  customer: 'Customer Y',
  carrier: 'Carrier 1',
  planned_shiped_date: 'Dec 23, 2024 , 4:00 PM UTC',
  header_state: 'Delivered',
  eta: 'Dec 23, 2024 , 4:00 PM UTC',
  pta: 'Dec 23, 2024 , 4:00 PM UTC',
  creation_date: 'Dec 23, 2024 , 4:00 PM UTC',
  notes: 'Handle with care',
  lmd: 'Dec 23, 2024 , 4:00 PM UTC',
},
{
  shipment_number: '0000000001258494',
  supplier: 'Supplier B',
  customer: 'Customer Y',
  carrier: 'Carrier 1',
  planned_shiped_date: 'Dec 23, 2024 , 4:00 PM UTC',
  header_state: 'Delivered',
  eta: 'Dec 23, 2024 , 4:00 PM UTC',
  pta: 'Dec 23, 2024 , 4:00 PM UTC',
  creation_date: 'Dec 23, 2024 , 4:00 PM UTC',
  notes: 'Handle with care',
  lmd: 'Dec 23, 2024 , 4:00 PM UTC',
},
{
  shipment_number: '0000000001258494',
  supplier: 'Supplier B',
  customer: 'Customer Y',
  carrier: 'Carrier 1',
  planned_shiped_date: 'Dec 23, 2024 , 4:00 PM UTC',
  header_state: 'Delivered',
  eta: 'Dec 23, 2024 , 4:00 PM UTC',
  pta: 'Dec 23, 2024 , 4:00 PM UTC',
  creation_date: 'Dec 23, 2024 , 4:00 PM UTC',
  notes: 'Handle with care',
  lmd: 'Dec 23, 2024 , 4:00 PM UTC',
},



];